import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import { PermissionGuard } from 'src/routes/components';

type AddMarketButtonProps = {
  onClick: () => void;
};

export default function AddMarketButton({ onClick }: AddMarketButtonProps) {
  const translate = useTranslate();

  return (
    <PermissionGuard resource="prediction-admin-events" action="update" fallback={<></>}>
      <Button variant="contained" startIcon={<Add />} onClick={onClick}>
        {translate('module.featuredMarkets.addButton')}
      </Button>
    </PermissionGuard>
  );
}
